export default __webpack_public_path__ + "static/media/ppu-logo.afc8a076.svg";